import axios from 'axios';

const http = axios.create({
  baseURL: process.env.REACT_APP_CAR_API_URL || '', 
  headers: {
    'accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token'); 
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});


// HTTP Methods

type IFetchOrDeleteRequestMethod = (url: string, options?: any) => Promise<any>;
type IPostOrPutRequestMethod = (url: string, data:any, options?: any) => Promise<any>;

export const fetchMethod: IFetchOrDeleteRequestMethod = async (url, options = {}) => {
  try {
    const response = await http.get(url, options);
    return response.data; 
  } catch (error) {
    throw error;
  }
  
}

export const postMethod: IPostOrPutRequestMethod = async (url, data, options = {}) => {
  try {
    const response = await http.post(url, data, options);
    return response.data;
  } catch (error) {
    throw error;
  }
  
}

export const putMethod: IPostOrPutRequestMethod = async (url, data, options = {}) => {
  try {
    const response = await http.put(url, data, options);
    return response.data;
  } catch (error) {
    throw error;
  }
  
}


export const deleteMethod: IFetchOrDeleteRequestMethod = async (url, options = {}) => {
  try {
    const response = await http.delete(url, options);
    return response.data;
  } catch (error) {
    throw error;
  }
  
}

export default http;
